import { apiClient } from "../apiClient";
import { TaskId } from "../../shared-types";
import { useMutation } from "react-query";

const startTask = (data: TaskId): Promise<string> =>
  apiClient.post("/task/start", data).then((resp) => resp.data);

export const useStartTask = (
  onSuccess?: (data: string) => void,
  onError?: () => void,
) => {
  const { isLoading, mutate } = useMutation(startTask, {
    onSuccess,
    onError,
  });

  return {
    isLoading,
    mutate,
  };
};
